import { Model } from 'vue-models'

export default class Device extends Model {
  static defaults () {
    return {
      name: 'tracking request',
      basePath: 'conventional-tracking-requests',
      computed: {
        __str__ () { return this.id }
      }
    }
  }
  static schema () {
    return {
      device_id: { type: String },
      current_position: { type: Object },
      previous_positions: { type: Array }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/device.js